import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { injectIntl, intlShape } from 'react-intl';
import { ReCaptcha } from 'react-recaptcha-v3';
import AffiliatePasswordRecoveryForm from '../AffiliatePasswordRecovery/AffiliatePasswordRecoveryForm';
import AffiliatePasswordRecoverySuccess from '../AffiliatePasswordRecovery/AffiliatePasswordRecoverySuccess';
import AffiliatePasswordRecoveryConfirm from '../AffiliatePasswordRecovery/AffiliatePasswordRecoveryConfirm';
import { getUrlParameter, shouldDisableRecaptcha } from '../../utils/utils';
import { webmaster } from '../../services/ApiService';

class AffiliatePasswordRecoveryModal extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      data: {
        email: '',
        new_password: '',
        reply_password: '',
        hash: '',
        recaptchaToken: '',
      },
      errors: {},
    };

    this.recaptcha = null;
  }

  componentDidMount() {
    const hash = getUrlParameter('hash');

    if (hash) {
      this.setState((prevState) => ({
        data: {
          ...prevState.data,
          hash: hash,
        },
      }));
      this.props.onStatusChange('password_recovery_confirm');
    }
  }

  onChange = (e) => {
    const { target } = e;

    this.setState((prevState) => ({
      data: {
        ...prevState.data,
        [target.name]: target.value,
      },
    }));
  };

  onSubmit = (e) => {
    e.preventDefault();

    if (shouldDisableRecaptcha()) {
      this.verifyCallback();
      return;
    }

    this.recaptcha.execute();
  };

  newPasswordValidation = (data) => {
    const errors = {};

    const { intl } = this.props;

    if (data.new_password.length < 6) {
      errors.new_password = intl.formatMessage({
        id: 'password.recovery.error.pass_length',
        defaultMessage: 'Your password must be a minimum of 6 letters or numbers.',
      });
    }

    if (data.new_password !== data.reply_password) {
      errors.reply_password = intl.formatMessage({
        id: 'password.recovery.error.pass_missmatch',
        defaultMessage: 'Your new password and confirmation password do not match.',
      });
    }

    return errors;
  };

  confirmSubmit = (e) => {
    e.preventDefault();

    const errors = this.newPasswordValidation(this.state.data);
    const { data } = this.state;

    this.setState((prevState) => ({
      ...prevState,
      errors,
    }));

    if (Object.keys(errors).length === 0) {
      const { new_password, reply_password, hash } = data;

      webmaster
        .passwordRecoveryNewPassword({
          new_password,
          reply_password,
          hash,
        })
        .then(() => {
          this.props.history.push('/publisher/sign_in?recovery_success=true');
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            this.setState((prevState) => ({
              errors: {
                response: error.response.data.error.message.message,
              },
            }));
          }
        });
    }
  };

  renderTitle = (status) => {
    let title = '';
    const { intl } = this.props;

    switch (status) {
      case 'password_recovery_start':
        title = intl.formatMessage({
          id: 'password.recovery.title.start',
          defaultMessage: 'Password Recovery',
        });
        break;

      case 'password_recovery_success':
        title = intl.formatMessage({
          id: 'password.recovery.title.success',
          defaultMessage: 'Succeed!',
        });
        break;

      case 'password_recovery_confirm':
        title = intl.formatMessage({
          id: 'password.recovery.title.confirm',
          defaultMessage: 'New Password',
        });
        break;

      default:
        title = intl.formatMessage({
          id: 'password.recovery.title.start',
          defaultMessage: 'Password Recovery',
        });
        break;
    }
    return title;
  };

  verifyCallback = (recaptchaToken) => {
    const isRecaptchaDisabled = shouldDisableRecaptcha();
    this.setState(
      (prevState) => ({
        ...prevState,
        data: {
          ...prevState.data,
          recaptchaToken: isRecaptchaDisabled ? '' : recaptchaToken,
        },
      }),
      () => {
        const { email, recaptchaToken } = this.state.data;
        if (email) {
          const token = isRecaptchaDisabled ? undefined : recaptchaToken;
          webmaster
            .passwordRecovery(email, token)
            .then(() => {
              this.props.onStatusChange('password_recovery_success');
            })
            .catch((error) => {
              if (error.response.data.error.message.type === 'api.recovery.email_not_found') {
                this.setState(() => ({
                  errors: {
                    email: error.response.data.error.message.message,
                  },
                }));
              } else {
                this.setState(() => ({
                  errors: {
                    response: error.response.data.error.message.message,
                  },
                }));
              }
            });
        }
      },
    );
  };

  render() {
    const { data, errors } = this.state;
    const { reacaptcha_sitekey, changeForm, status } = this.props;
    return (
      <>
        {!shouldDisableRecaptcha() && reacaptcha_sitekey && reacaptcha_sitekey.v3 && (
          <ReCaptcha
            ref={(el) => {
              this.recaptcha = el;
            }}
            sitekey={reacaptcha_sitekey.v3}
            size="invisible"
            render="explicit"
            action="recovery"
            verifyCallback={this.verifyCallback}
          />
        )}
        <div className="auth-modal-innner">
          <div className="form row">
            <h4 className="auth-modal-innner-title text-center">{this.renderTitle(status)}</h4>

            {errors.response && <span className="form-error">{errors.response}</span>}

            {status === 'password_recovery_start' && (
              <AffiliatePasswordRecoveryForm
                submit={this.onSubmit}
                change={this.onChange}
                data={data}
                errors={errors}
              />
            )}
            {status === 'password_recovery_success' && (
              <AffiliatePasswordRecoverySuccess changeForm={changeForm} />
            )}
            {status === 'password_recovery_confirm' && (
              <AffiliatePasswordRecoveryConfirm
                submit={this.confirmSubmit}
                change={this.onChange}
                data={data}
                errors={errors}
              />
            )}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  reacaptcha_sitekey: state.app.authSettings.recaptcha,
});

export default connect(mapStateToProps)(injectIntl(withRouter(AffiliatePasswordRecoveryModal)));
